import React from 'react';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { updateUnsettledBadgePayment } from './helpers/updateUnsettledBadgePayment';
import { makeAccountsList } from '../../../shared/helpers/makeAccountsList';
import { makeEstimatesList } from '../../../shared/helpers/makeEstimatesList';
import { makeExpendituresList } from '../../../shared/helpers/makeExpendituresList';
import { makePartnersList } from '../../../shared/helpers/makePartnersList';
import { updateBalanceData } from '../../../shared/helpers/updateBalanceData';
import { BankIcon } from '../../../TemporaryConmonents/Accounts/BankIcon';

const getAccountBankIcon = (account) => (
    <BankIcon type={account.integration} width={18} height={16} />
);

export const fetchPayments = createAsyncThunk(
    'payments/fetchPayments',
    async (options, thunkApi) => {
        try {
            const response = await fetch(options, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            const balanceResponse = await fetch(routable.getRoute('getCompanyBalanceData'), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            const balance = await balanceResponse.json();

            await companyPaymentManager.tabs.payments.table.renderTotalBalanceBlock(balance.total);
            await companyPaymentManager.tabs.payments.table.updateAccountBalancesPrototype(
                balance.balances
            );

            const payment = await response.json();

            if (payment.data.unsettled_sums_with_currencies.length === 1) {
                $(document)
                    .find('.badgePayment')
                    .find('span')
                    .text(
                        `${i18next.t(
                            'filesSlice.action.fetchPayments.badgePayment.with_sum'
                        )} ${numberFormatter.formatMoney(
                            payment.data.unsettled_sums_with_currencies[0].total_sum,
                            2,
                            payment.data.unsettled_sums_with_currencies[0].short_code
                        )}`
                    );
                $(document).find('.badgePayment').css({
                    display: 'flex',
                });
            } else if (payment.data.unsettled_sums_with_currencies.length > 1) {
                $(document)
                    .find('.badgePayment')
                    .find('span')
                    .text(i18next.t('filesSlice.action.fetchPayments.badgePayment'));
                $(document).find('.badgePayment').css({
                    display: 'flex',
                });
            } else {
                $(document).find('.badgePayment').hide();
            }

            await companyPaymentManager.tabs.payments.updateOverallPanel(
                payment.data.overall_incoming_transfers,
                payment.data.overall_outgoing_transfers,
                payment.data.overall_debit,
                payment.data.overall_credit,
                payment.data.overall_saldo
            );

            return payment.data;
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
);

export const fetchPaymentsFilters = createAsyncThunk(
    'payments/fetchPaymentsFilters',
    async (options, thunkApi) => {
        try {
            const response = await fetch(options, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            updateBalanceData();

            const payment = await response.json();

            updateUnsettledBadgePayment(payment?.data);

            await companyPaymentManager.tabs.payments.updateOverallPanel(
                payment.data.overall_incoming_transfers,
                payment.data.overall_outgoing_transfers,
                payment.data.overall_debit,
                payment.data.overall_credit,
                payment.data.overall_saldo
            );

            await $(document).find('#payments_count').text(payment.data.search_count);

            return payment.data;
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
);

export const fetchPaymentsForEdit = createAsyncThunk(
    'payments/fetchPaymentsForEdit',
    async (page, thunkApi) => {
        try {
            const state = thunkApi.getState();
            const qs = state.paymentReducer?.queryString || `page=${page}`;

            const withPage = qs.match(/(^|&)page=\d+/)
                ? qs.replace(/(^|&)page=\d+/, (m) => m.replace(/\d+/, String(page)))
                : `page=${page}&${qs}`;

            const url = `${routable.getRoute('searchCompanyPaymentOperationsReact')}?${withPage}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            const balanceResponse = await fetch(routable.getRoute('getCompanyBalanceData'), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });
            const balance = await balanceResponse.json();
            await companyPaymentManager.tabs.payments.table.renderTotalBalanceBlock(balance.total);
            await companyPaymentManager.tabs.payments.table.updateAccountBalancesPrototype(
                balance.balances
            );

            const payment = await response.json();
            updateUnsettledBadgePayment(payment?.data);

            if (payment?.data?.payments.length === 0 && payment?.data?.pagination?.current > 1) {
                const action = await thunkApi.dispatch(fetchPaymentsForEdit(page - 1));
                if (action.error) return thunkApi.rejectWithValue(action.error);
                return action.payload;
            }
            await companyPaymentManager.tabs.payments.updateOverallPanel(
                payment.data.overall_incoming_transfers,
                payment.data.overall_outgoing_transfers,
                payment.data.overall_debit,
                payment.data.overall_credit,
                payment.data.overall_saldo
            );
            await $(document).find('#payments_count').text(payment.data.search_count);

            // loader.hide();
            return payment.data;
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
);

export const fetchAccounts = createAsyncThunk('payments/fetchAccounts', async (_, thunkApi) => {
    try {
        const response = await fetch(routable.getRoute('getAccountList'), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
        const accounts = await response.json();

        const { accountsList, accountsListArchive } = makeAccountsList(
            accounts,
            getAccountBankIcon
        );

        return { accountsList, accountsListArchive };
    } catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});

export const fetchDataForEdit = createAsyncThunk(
    'payments/fetchDataForEdit',
    async (_, thunkApi) => {
        try {
            const responseAccounts = await fetch(routable.getRoute('getAccountList'), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            const responseExpenditures = await fetch(routable.getRoute('getExpenditure'), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            const responsePartnerForPayments = await fetch(
                routable.getRoute('getPartnerForPayments'),
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }
            );
            const responseEstimateForPayments = await fetch(
                routable.getRoute('getEstimateForPayments'),
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }
            );

            const expendituresStatus = responseExpenditures.status;
            let expenditures = { data: [] };
            if (expendituresStatus === 200) {
                expenditures = await responseExpenditures.json();
            }

            const estimateForPayments = await responseEstimateForPayments.json();
            const partnerForPayments = await responsePartnerForPayments.json();
            const accounts = await responseAccounts.json();

            const estimatesList = makeEstimatesList(estimateForPayments);
            const partnersList = makePartnersList(partnerForPayments);
            const { incomeList, expenseList } = makeExpendituresList(expenditures);
            const { accountsList, accountsListArchive } = makeAccountsList(
                accounts,
                getAccountBankIcon
            );

            return {
                accountsList,
                expenseList,
                incomeList,
                partnersList,
                estimatesList,
                accountsListArchive,
            };
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
);

export const fetchDataForSecondStep = createAsyncThunk(
    'payments/fetchDataForSecondStep',
    async (_, thunkApi) => {
        try {
            const responseExpenditures = await fetch(routable.getRoute('getExpenditure'), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            const responsePartnerForPayments = await fetch(
                routable.getRoute('getPartnerForPayments'),
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }
            );
            const responseEstimateForPayments = await fetch(
                routable.getRoute('getEstimateForPayments'),
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }
            );
            const expenditures = await responseExpenditures.json();
            const estimateForPayments = await responseEstimateForPayments.json();
            const partnerForPayments = await responsePartnerForPayments.json();

            const estimatesList = makeEstimatesList(estimateForPayments);
            const partnersList = makePartnersList(partnerForPayments);
            const { incomeList, expenseList } = makeExpendituresList(expenditures);

            return { expenseList, incomeList, partnersList, estimatesList };
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
);

export const fetchAddPayment = createAsyncThunk(
    'payments/fetchAddPayment',
    async (option, thunkApi) => {
        try {
            const responseAdd = await fetch(option.url, {
                method: 'POST',
                body: option.formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });
            const addPayment = await responseAdd.json();

            if (responseAdd.ok && !!commentGuid && !!commentValue) {
                const saveCommentRequest = async () => {
                    const urlSaveComment = helpable.replaceUrlParameters(
                        routable.getRoute('paymentRequestStatus'),
                        {
                            _guid_: commentGuid,
                        }
                    );
                    const formDataComment = new FormData();
                    formDataComment.append('comment', commentValue);

                    const response = await fetch(urlSaveComment, {
                        method: 'POST',
                        body: formDataComment,
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    });
                    if (response.ok) {
                        commentGuid = null;
                        commentValue = null;
                    }
                };

                await saveCommentRequest();
            }

            if (addPayment.errors) {
                await option.errorHandler(addPayment);
            } else if (addPayment.status === 'error') {
                option.bankIntegrationErrorHandler(addPayment);
            } else {
                const response = await fetch(
                    `${routable.getRoute('searchCompanyPaymentOperations')}?page=${option.page}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    }
                );
                const balanceResponse = await fetch(routable.getRoute('getCompanyBalanceData'), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });

                const balance = await balanceResponse.json();

                await companyPaymentManager.tabs.payments.table.renderTotalBalanceBlock(
                    balance.total
                );
                await companyPaymentManager.tabs.payments.table.updateAccountBalancesPrototype(
                    balance.balances
                );

                const payment = await response.json();

                await companyPaymentManager.tabs.payments.updateOverallPanel(
                    payment.data.overall_incoming_transfers,
                    payment.data.overall_outgoing_transfers,
                    payment.data.overall_debit,
                    payment.data.overall_credit,
                    payment.data.overall_saldo
                );

                await option.callback(payment);
                await loader.hide();

                return payment.data;
            }
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
);
